<template>
  <button
    @click="scrollTop"
    class="scrollTop"
    :class="[{ 'scrollTop--visible': visible }, { 'scrollTop--mobile': $device.isMobile }]"
  >
    <span class="scrollTop__icon icon-chevron-up" />
  </button>
</template>

<script>
export default {
  name: 'ScrollTop',
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.scrollTop {
  $root: &;
  position: fixed;
  bottom: 2rem;
  right: 8rem;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  border: 1px solid $cMain;
  background-color: $cWhite;
  opacity: 0;
  pointer-events: none;
  z-index: 100;
  transition: background-color $tr, opacity $tr;

  &:hover {
    background-color: $cMain;

    #{$root}__icon {
      color: $cWhite;
    }
  }

  &__icon {
    font-size: 1rem;
    color: $cMain;
    transition: color $tr;
  }

  &--visible {
    opacity: 1;
    pointer-events: all;
  }

  &--mobile {
    bottom: 1rem;
    right: 1rem;
  }
}
</style>
